import {Component, OnInit, OnDestroy, Input} from '@angular/core';
import {HttpErrorResponse, HttpHeaders, HttpResponse} from '@angular/common/http';
import {ActivatedRoute, Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {ModalDismissReasons, NgbModal} from '@ng-bootstrap/ng-bootstrap';
import {JhiEventManager, JhiParseLinks, JhiAlertService} from 'ng-jhipster';
import * as moment from 'jalali-moment';
import {NgxSpinnerService} from 'ngx-spinner';
import {AccountService} from '../../singelton/account.service';
import {ProjectService} from "../../entities/project/project.service";
import {IProject} from "../../shared/model/project.model";

@Component({
  selector: 'app-advanced-search-project',
  templateUrl: './advanced-search-project.component.html'
})
export class AdvancedSearchProjectComponent implements OnInit {
  @Input() term;
  width: any = '';

  currentAccount: any;
  projects: IProject[];
  error: any;
  success: any;
  eventSubscriber: Subscription;
  routeData: any;
  links: any;
  pageCount: any;
  start: any;
  end: any;
  totalItems: any;
  queryCount: any;
  itemsPerPage: any;
  page: any;
  predicate: any;
  previousPage: any;
  reverse: any;
  closeResult: string;

  constructor(protected projectService: ProjectService,
              protected parseLinks: JhiParseLinks,
              protected jhiAlertService: JhiAlertService,
              public accountService: AccountService,
              private modalService: NgbModal,
              protected activatedRoute: ActivatedRoute,
              protected router: Router,
              private spinner: NgxSpinnerService,
              protected eventManager: JhiEventManager) {

    this.itemsPerPage = 3;
    this.page = 1;
    this.predicate = 'id';
    this.reverse = 'asc';

  }


  loadPage2(param) {
    if (this.predicate === param) {
      if (this.reverse === 'asc') {
        this.reverse = 'desc';
      } else {
        this.reverse = 'asc';
      }
    } else {
      this.reverse = 'asc';
    }
    this.predicate = param;
    this.transition(this.page);
  }


  transition(page) {
    this.search(page, false);
  }

  ngOnInit() {
    this.search(this.page, true);
  }


  trackId(index: number, item: IProject) {
    return item.id;
  }

  protected paginateProjects(data: IProject[], headers: HttpHeaders, firstLoad) {
    this.totalItems = parseInt(headers.get('X-Total-Count'), 10);
    this.queryCount = this.totalItems;


    this.start = ((this.page - 1) * this.itemsPerPage) + 1;
    const temp = this.totalItems % this.itemsPerPage;
    this.pageCount = this.totalItems / this.itemsPerPage;
    this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);

    if (temp > 0) {
      if (this.page <= (Math.round(this.pageCount) - 1)) {
        this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
      } else {
        if (this.itemsPerPage < this.totalItems) {
          this.end = (Number(this.page - 1) * Number(this.itemsPerPage)) + Number(this.itemsPerPage);
        } else {
          this.end = Number((this.page - 1) * this.itemsPerPage) + Number(temp);

        }
      }
    } else {

      this.end = Number((this.page - 1) * this.itemsPerPage) + Number(this.itemsPerPage);

    }
    if (((this.end)) > ((this.totalItems))) {
      this.end = this.totalItems;
    }

    this.projects = data;
    this.spinner.hide();
  }

  protected onError(errorMessage: string) {
  }


  search(page, firstLoad) {
    this.spinner.show();
    if (page) {
      this.page = page;
    } else {
      this.page = 1;

    }

    this.accountService.identity().then(account => {
      const term = this.term;
      this.projectService
        .searchAdvanced({
          page: this.page - 1,
          size: this.itemsPerPage,
          sort: this.sort(),
          term,
        })
        .subscribe(
          (res: HttpResponse<IProject[]>) => this.paginateProjects(res.body, res.headers, firstLoad),
          (res: HttpErrorResponse) => this.onError(res.message)
        );
    });
  }


  sort() {
    const result = [this.predicate + ',' + (this.reverse)];
    return result;
  }

  percentCellRenderer(value, status, status_2) {
    const today = new Date();
    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }

    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    value = diffDays;
    const valueNumber = Number(value + '');
    let valueStr = '';
    const eDivPercentBar = document.createElement('div');
    eDivPercentBar.className = '';
    const eValue = document.createElement('div');
    valueStr = 'Expired';

    eValue.className = 'progress-bar progress-bar-striped bg-primary';

    if (status_2 && status_2 === 'Completed') {
      valueStr = 'تکمیل شده';
      eValue.style.width = '100%';
      eValue.style.paddingLeft = '1px';
      eValue.style.color = 'green';

    } else {
      if (valueNumber < 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز گذشته';
      } else if (valueNumber === 0) {
        eValue.style.width = '100%';
        eValue.className = 'progress-bar progress-bar-striped bg-danger';
        valueStr = '' + Math.abs(value) + ' روز مانده';
      } else if (valueNumber < 30 && valueNumber > 0) {
        eValue.style.width = '80%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-warning';
      } else if (valueNumber < 60 && valueNumber > 0) {
        eValue.style.width = '60%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-info';
      } else if (valueNumber < 90 && valueNumber > 0) {
        valueStr = value + ' روز';
        eValue.style.width = '40%';
        eValue.className = 'progress-bar progress-bar-striped bg-succsess';
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          // alert(status);
          valueStr = 'بدون مهلت';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        } else {
          valueStr = 'Not Uploaded';
          eValue.style.width = '1%';
          eValue.style.paddingLeft = '1px';
          eValue.style.color = 'red';
        }
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      } else {
        eValue.style.width = '45%';
        valueStr = value + ' روز';
        eValue.className = 'progress-bar progress-bar-striped bg-primary';
      }
    }
    const eOuterDiv = document.createElement('div');
    eOuterDiv.className = 'progress mb-2';
    eOuterDiv.style.marginTop = '12px';
    eOuterDiv.appendChild(eValue);
    const re = /&lt;/gi;
    const re2 = /&gt;/gi;
    const str = eOuterDiv.outerHTML;
    const newstr = str.replace(re, '<').replace(re2, '>');
    const newstr2 = str.replace(re, '>');
    return valueStr;
  }


  styleObject(value, status, status_2): Object {
    const today = new Date();

    const dateExpiration = new Date(value + '');
    let timeDiff = (dateExpiration.getTime() - today.getTime());
    if (dateExpiration.getTime < today.getTime) {
      timeDiff = -1 * timeDiff;
    }
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    value = diffDays;
    const valueNumber = Number(value + '');

    if (status_2 && status_2 === 'Completed') {
      this.width = '100%';
      return {width: this.width, 'background-color': '#168016'};

    } else {

      if (valueNumber <= 0) {
        this.width = '100%';
        return {width: this.width, 'background-color': '#dc3545'};
      } else if (valueNumber < 7 && valueNumber > 0) {
        this.width = '80%';
        return {width: this.width, 'background-color': '#ffc107'};
      } else if (valueNumber < 60 && valueNumber > 0) {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (valueNumber < 90 && valueNumber > 0) {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      } else if (isNaN(valueNumber)) {
        if (status && status === 'Optional') {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        } else {
          this.width = '1%';
          return {'color': '#dc3545', paddingLeft: '1px', 'background-color': '#eaeaea'};
        }
      } else {
        this.width = '75%';
        return {width: this.width, 'background-color': '#17a2b8'};
      }
    }
  }

  parseDate(value) {
    let jalaliDate5 = '-';
    if (value) {
      jalaliDate5 = moment(new Date(value)).locale('fa').format('jYYYY/jM/jD');
    }
    return jalaliDate5;
  }

  parseStepPrj(step, status) {
    let return_value = '';
    if (step === 'marketing') {
      return_value = 'آشنایی اولیه';
    } else if (step === 'preInvoice') {
      return_value = 'برآورد نیاز/صدور پیش فاکتور';
    } else if (step === 'sendFile') {
      return_value = 'ارسال پیش فاکتور';
    } else if (step === 'finalFollow') {
      return_value = 'مذاکره نهایی';
    } else if (step === 'completed') {


      if (status === 'colesd_unfinished') {
        // return_value = 'تعطیل شده';
        return_value = 'قرارداد نشد';
      } else if (status === 'colesd_buy_another') {
        // return_value = 'خرید از دیگری';
        return_value = 'قرارداد نشد';

      } else if (status === 'colesd_contract') {
        return_value = 'قرارداد شد';
      } else if (status === 'closed_other') {
        // return_value = 'بسته شده';
        return_value = 'قرارداد نشد';

      }
    }
    return return_value;
  }


  parseStatusPrj(value) {
    let return_value = '';
    if (value === 'notStarted') {
      return_value = 'شروع نشده';
    } else if (value === 'during') {
      return_value = 'درجریان';
    } else if (value === 'noFollowUp') {
      return_value = 'فاقد پیگیری';
    } else if (value === 'colesd_unfinished') {
      return_value = 'تعطیل شده';
    } else if (value === 'colesd_buy_another') {
      return_value = 'خرید از دیگری';
    } else if (value === 'colesd_contract') {
      return_value = 'قرارداد شد';
    } else if (value === 'closed_other') {
      return_value = 'بسته شده';
    }
    return return_value;
  }


}
